module.exports = __webpack_public_path__ + "media/images/ninestars/clients/client-1-19430ae2ef882f844c04cf09dfa33245.png";